import { createFileRoute } from '@tanstack/react-router';
import { PoliciesPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/policies')({
  component: PoliciesPage,
});
